/**
 * Payments
 * Payments APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { WebhookControllerWebhookRequest } from '../model/webhookControllerWebhookRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class PersonaPayWebhookService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xRSWebhookEvent 
   * @param xRSWebhookId 
   * @param xRSOrgId 
   * @param webhookControllerWebhookRequest 
   */
  public async webhookControllerWebhook(xRSWebhookEvent: string, xRSWebhookId: string, xRSOrgId: string, webhookControllerWebhookRequest: WebhookControllerWebhookRequest, ): Promise<any> {
    if (xRSWebhookEvent === null || xRSWebhookEvent === undefined) {
      throw new Error('Required parameter xRSWebhookEvent was null or undefined when calling webhookControllerWebhook.');
    }
    if (xRSWebhookId === null || xRSWebhookId === undefined) {
      throw new Error('Required parameter xRSWebhookId was null or undefined when calling webhookControllerWebhook.');
    }
    if (xRSOrgId === null || xRSOrgId === undefined) {
      throw new Error('Required parameter xRSOrgId was null or undefined when calling webhookControllerWebhook.');
    }
    if (webhookControllerWebhookRequest === null || webhookControllerWebhookRequest === undefined) {
      throw new Error('Required parameter webhookControllerWebhookRequest was null or undefined when calling webhookControllerWebhook.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xRSWebhookEvent) {
      localVarHeaders['X-RS-WebhookEvent'] = String(xRSWebhookEvent);
    }
    if (xRSWebhookId) {
      localVarHeaders['X-RS-WebhookId'] = String(xRSWebhookId);
    }
    if (xRSOrgId) {
      localVarHeaders['X-RS-OrgId'] = String(xRSOrgId);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/payments/persona-pay/webhook`,
        data: webhookControllerWebhookRequest,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
